import React from 'react';
import { Button } from '@zurich-primitives/button';
import { ReactComponent as AttachIcon } from 'app/assets/Icons/AttachWhite.svg';
import classnames from 'classnames';
import styles from './DragDropUpload.module.scss';
import { IDragDropUpload } from './DragDropUpoad.interface';

export const DragDropUpload: React.FC<IDragDropUpload> = ({
  handleDrop,
  handleDragOver,
  handleDragEnter,
  handleDragLeave,
  handleButtonClick,
  isDragging,
  errorText,
  uploadText,
  buttonText = 'Upload File',
  className
}) => {
  return (
    <section
      className={classnames(
        styles['upload-area'],
        {
          [styles.dragging]: isDragging
        },
        className
      )}
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      aria-label="File upload area"
    >
      <Button
        onClick={handleButtonClick}
        className={styles['upload-button']}
        variant="secondary"
      >
        <Button.Icon>
          <AttachIcon />
        </Button.Icon>
        <Button.Label>{buttonText}</Button.Label>
      </Button>

      {uploadText && <p className={styles['upload-text']}>{uploadText}</p>}

      {errorText && <span className={styles.error}>{errorText}</span>}
    </section>
  );
};
